// Client V2 common imports
const useMatchMedia = require('client-v2/common/hooks/match-media')

function useHasSeriesFeed() {
  let hasSeriesFeed = true
  const isWindowTooNarrow = useMatchMedia('(max-width: 799px)')
  const isWindowTooShort = useMatchMedia('(max-height: 599px)')
  if (isWindowTooNarrow || isWindowTooShort) {
    hasSeriesFeed = false
  }
  return hasSeriesFeed
}

module.exports = {
  useHasSeriesFeed
}
